// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import DataConnector from 'connect/DataConnector';
import * as CrisprConstants from 'constants/CRISPRConstants';
import {CRISPRVector} from 'constants/CRISPRConstants';

import CompletedAssemblyStep from './CompletedAssemblyStep';
import CRISPRAssemblyStore, {CRISPRAssemblyState} from './CRISPRAssemblyStore';
import FinalizeAssembliesStep from './FinalizeAssembliesStep';
import SelectVectorStep from './SelectVectorStep';

const {ASSEMBLY_STEP} = CrisprConstants;

export function CRISPRAssemblyOptions(): JSX.Element {
  return <ul className="nav navbar-nav form-inline" />;
}

class CRISPRAssemblyTabConnector extends DataConnector<
  CRISPRAssemblyTabProps,
  CRISPRAssemblyTabEnhancedProps
> {
  override shouldSubscribeToRedux = false;
  override stores = [CRISPRAssemblyStore];

  enhanceProps(): CRISPRAssemblyTabEnhancedProps {
    return {
      ...this.crisprAssemblyStore().getAssemblyState(this.props.assemblyCid),
      ...this.crisprAssemblyStore().getState(),
    };
  }
}

interface CRISPRAssemblyTabProps {
  assemblyCid: string;
  sequenceName: string;
}
interface CRISPRAssemblyTabEnhancedProps extends CRISPRAssemblyState {
  vectors: Array<CRISPRVector>;
  vectorLoading: boolean;
}

function CRISPRAssemblyTab(props: CRISPRAssemblyTabProps & CRISPRAssemblyTabEnhancedProps): JSX.Element {
  return (
    <div>
      {(() => {
        switch (props.step) {
          case ASSEMBLY_STEP.SELECT_VECTOR:
            return (
              <SelectVectorStep
                assemblyCid={props.assemblyCid}
                vectors={props.vectors}
                vectorLoading={props.vectorLoading}
                biojsSequence={props.biojsSequence}
                enzyme={props.enzyme}
                existingSequenceInputState={props.existingSequenceInputState}
                fileInputState={props.fileInputState}
                finalizingSelectedVector={props.finalizingSelectedVector}
                // @ts-expect-error: unclear if values are allowed to be null or not at this point
                insertionRegion={props.insertionRegion}
                vectorSelectorState={props.vectorSelectorState}
                vectorSourceType={props.vectorSourceType}
              />
            );
          case ASSEMBLY_STEP.FINALIZE_ASSEMBLIES:
            return (
              <FinalizeAssembliesStep
                analysis={props.analysis}
                assemblyCid={props.assemblyCid}
                assemblies={props.assemblies}
                assembliesFolder={props.assembliesFolder}
                finalizingAssemblies={props.finalizingAssemblies}
              />
            );
          case ASSEMBLY_STEP.COMPLETED_ASSEMBLY:
            return (
              <CompletedAssemblyStep
                assemblyCid={props.assemblyCid}
                assemblyPrimers={props.assemblyPrimers}
                sequenceName={props.sequenceName}
              />
            );
          default:
            return null;
        }
      })()}
    </div>
  );
}

export const ConnectedCRISPRAssemblyTab = CRISPRAssemblyTabConnector.connect(CRISPRAssemblyTab);
